import React, {useState, useRef,useEffect} from 'react'
import { GoogleMap, useJsApiLoader, Marker,InfoWindow } from '@react-google-maps/api';
import Header from 'components/Headers/Header';
import { Button, Container } from 'reactstrap';
import { getMapLoc } from 'network/ApiAxiosTickets';
import DatePicker from "react-datepicker"
import {ddns} from '../../../../package.json'


const containerStyle = {
  width: '100vh',
  height: '100vh'
};

const center = {
  lat: 37.089109,lng: -8.227233
};


function Stats() {
  useEffect(() => {
    handleMarkers()
  }, [])

  const [map, setMap] = React.useState(null)
  const [activeMarker, setActiveMarker] = useState(null);
  const [markers, setMarkers] = useState();
  const [startDate, setStartDate] = useState(new Date());

  const handleMarkers =async()=>{
    const res=await getMapLoc(startDate)
    if(res.data.success){
      setMarkers(res.data.result)
    }
  }
  
  
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: 'AIzaSyAra1HaFtCM8DsSrI2Gdzzn2L2t5gFqZjo'
  })

  const onLoad = React.useCallback(function callback(map) {
    const bounds = new window.google.maps.LatLngBounds(center);
    map.fitBounds(bounds);
    setMap(map)
  }, [])

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null)
  }, [])

  const handleActiveMarker = (marker) => {
    if (marker === activeMarker) {
      return;
    }
    setActiveMarker(marker);
  };

  return (
  <>
    <Header/>
    <Container>
    <DatePicker
        selected={startDate}
        onChange={(e)=>{setStartDate(e)}}
        startDate={startDate}
        inline
        calendarStartDay={1}
        dateFormat="dd/MM/yyyy"
    />
    <Button onClick={handleMarkers}>Go</Button>
        
        <div>Stats</div>
        {isLoaded && <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={13}
            onLoad={onLoad}
            onUnmount={onUnmount}
        >
            {markers && markers.map(({ _id, Seller,clientName,total,createdAt,Loc }) => (
                <Marker
                key={_id}
                position={Loc}
                icon={{url:ddns + '/userfiles/' + Seller.email + '/pics/' + Seller.picture , scaledSize:new google.maps.Size(30,30)}}
                onClick={() => handleActiveMarker(_id)}
                >
                {activeMarker === _id ? (
                    <InfoWindow onCloseClick={() => setActiveMarker(null)}>
                    <div>
                      <h1>{Seller.name}</h1>
                      <hr/>
                      <p>
                        Cliente Name: {clientName}
                        <br/>
                        Total: {total}
                      </p>
                      <hr/>
                      {createdAt}
                    </div>
                    </InfoWindow>
                ) : null}
                </Marker>
            ))}
            
            
            { /* Child components, such as markers, info windows, etc. */ }
            <></>
        </GoogleMap>}


        



    </Container>
  </>
  )
}

export default Stats